import NotificationProvider from "./components/Notifination/ToastNotification";
import Routings from "./routes";
function App() {
  return (
    <div className="App">
      <NotificationProvider>
        <Routings />
      </NotificationProvider>
    </div>
  );
}

export default App;
